import Raven from 'raven-js';
import * as Icons from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
/*
  Converts a UIComponents icon name to a Foundations icon component.
  This file is supposed to be temporary, and will either:
    - Be removed after all actionConfigs have been updated to pass an icon component directly, or
    - Be replaced by a new component: https://git.hubteam.com/HubSpot/trellis-forum/discussions/63
 */

const ALIAS_TO_NAME = {
  'comment-o': 'comments',
  'comments-o': 'comments',
  contact: 'contacts',
  copy: 'duplicate',
  pencil: 'edit',
  'external-link': 'externalLink',
  photo: 'insertImage',
  chain: 'link',
  'upload-light': 'upload',
  eye: 'view',
  'warning-triangle': 'warning'
};
export const getTrellisIconComponent = iconName => {
  // Handle icon aliases
  const standardIconName = ALIAS_TO_NAME[iconName] || iconName;

  // Name conversion from migration guide
  // https://product.hubteam.com/docs/trellis-migration-guide/static/icon-migration.html#migration
  const componentName = `${standardIconName.charAt(0).toUpperCase()}${standardIconName.slice(1)}Icon`;
  const IconComponent = Icons[componentName];
  if (IconComponent) {
    return IconComponent;
  } else {
    console.error(`Icon component not found. componentName: ${componentName}, iconName: ${iconName}`);
    Raven.captureException(new Error('Icon component not found'), {
      extra: {
        componentName,
        iconName
      }
    });
    return undefined;
  }
};
export const CardActionIcon = ({
  name,
  color
}) => {
  if (!name) {
    return undefined;
  }
  const IconComponent = getTrellisIconComponent(name);
  if (IconComponent) {
    return /*#__PURE__*/_jsx(IconComponent, {
      color: color
    });
  }
  return undefined;
};